import $ from 'jquery';

/**
 * Shows an approval dialog for one or multiple images
 * @param {Object} options - Configuration options
 * @param {string|Array} options.images - Single image URL or array of image objects with {url, label} structure
 * @param {string} options.title - Dialog title
 * @param {string} options.description - Description text shown below images
 * @param {Function} options.onApprove - Callback when user approves (for single image) or selects an image (for multiple)
 * @param {Function} [options.onCancel] - Optional callback when user cancels
 * @param {Object} [options.imageOptions] - Additional options for image display
 * @param {number} [options.imageOptions.maxHeight=450] - Maximum height for images
 * @param {boolean} [options.imageOptions.showLabels=false] - Whether to show labels for multiple images
 */
export function showApprovalDialog(options) {
  const {
    images,
    title = 'Anteprima immagine',
    description = 'Se sei soddisfatto del risultato, clicca su "Accetta"',
    onApprove,
    onCancel,
    imageOptions = {},
  } = options;

  const { maxHeight = 450, showLabels = false } = imageOptions;

  // Clean up any existing modal and its event listeners
  const existingModal = $('#approvalDialogModal');
  if (existingModal.length) {
    existingModal.off('hidden.bs.modal');
    existingModal.modal('hide');
    existingModal.remove();
  }

  const isSingleImage = typeof images === 'string' || !Array.isArray(images);
  const imageList = isSingleImage ? [{ url: images }] : images;

  // Create and show the main modal
  const modalHtml = `
    <div class="modal fade" id="approvalDialogModal" tabindex="-1" role="dialog" style="padding-top: 10vh;">
      <div class="modal-dialog ${
        isSingleImage ? 'modal-lg' : 'modal-xxl'
      }" role="document" style="${isSingleImage ? '' : 'max-width: 95vw;'}">
        <div class="modal-content">
          <div class="modal-header bg-primary text-white">
            <h5 class="modal-title">${title}</h5>
            <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="max-height: 70vh; overflow-y: auto; padding: 25px;">
            <div class="${
              isSingleImage
                ? 'text-center'
                : 'd-flex justify-content-between flex-nowrap'
            }">
              ${imageList
                .map(
                  (image) => `
                <div class="${isSingleImage ? '' : 'px-3'}" style="${
                    isSingleImage ? '' : 'flex: 1;'
                  }">
                  <div class="card shadow-sm ${
                    isSingleImage ? '' : 'image-option'
                  }" 
                       ${isSingleImage ? '' : `data-image-url="${image.url}"`}
                       style="cursor: ${
                         isSingleImage ? 'default' : 'pointer'
                       }; height: 100%; border-radius: 8px; transition: transform 0.2s, box-shadow 0.2s; display: inline-block; position: relative; padding: 5px;">
                    <div class="card-img-top" style="height: ${maxHeight}px; overflow: hidden; display: flex; align-items: center; justify-content: center; position: relative;">
                      <div class="image-protection-overlay"></div>
                      <img src="${
                        image.url
                      }" class="img-fluid protected-image" style="max-height: 100%; max-width: 100%; object-fit: contain;" alt="${
                    image.label || 'Image'
                  }">
                    </div>
                    ${
                      showLabels && image.label
                        ? `
                      <div class="card-body p-2">
                        <p class="card-text text-center mb-0">${image.label}</p>
                      </div>
                    `
                        : ''
                    }
                  </div>
                </div>
              `
                )
                .join('')}
            </div>
            <div class="row mt-3">
              <div class="col-12 text-center">
                <p class="text-muted">${description}</p>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Annulla</button>
            ${
              isSingleImage
                ? `
              <button type="button" class="btn btn-primary" id="approveButton">Accetta</button>
            `
                : ''
            }
          </div>
        </div>
      </div>
    </div>
  `;

  // Add modal to body
  $('body').append(modalHtml);

  // Show modal immediately
  $('#approvalDialogModal').modal({
    backdrop: 'static',
    keyboard: true,
  });

  // Handle single image approval
  if (isSingleImage) {
    $('#approveButton').on('click', function () {
      $('#approvalDialogModal').modal('hide');
      onApprove(images);
    });
  } else {
    // Handle multiple image selection
    $('.image-option').on('click', function () {
      const selectedImage = $(this).data('image-url');
      $('#approvalDialogModal').modal('hide');
      onApprove(selectedImage);
    });
  }

  // Handle cancel
  $('#approvalDialogModal').on('hidden.bs.modal', function () {
    if (onCancel) {
      onCancel();
    }
    $(this).remove();
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open');
  });
}
